/**
 * The transfer policy's own lock (after registration, a transfer in or a change of registrant: a
 * `TRANSFER_LOCK` row with an end date) keeps a domain locked: the server refuses to unlock it
 * until then (`crates/lifecycle/src/transfer.rs`). The unlock dialog says so up front instead of
 * offering a button that can only be refused.
 *
 * `undefined`: nothing holds the lock; `null`: held with no end date; else the end (ISO).
 */
export function transferLockHeldUntil(locks: readonly { lock_type: string; auto_release_at?: string | null }[], now: number): string | null | undefined {
  let until: string | undefined;
  for (const l of locks) {
    if (l.lock_type !== 'TRANSFER_LOCK') continue;
    if (!l.auto_release_at) return null;
    if (Date.parse(l.auto_release_at) <= now) continue;
    if (until === undefined || Date.parse(l.auto_release_at) > Date.parse(until)) until = l.auto_release_at;
  }
  return until;
}
